"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ApplicationLayoutBodyBottomBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var ApplicationLayoutBodyBottomBar = function ApplicationLayoutBodyBottomBar(_ref) {
  var className = _ref.className,
      buttonAlignment = _ref.buttonAlignment,
      useBodyPaddings = _ref.useBodyPaddings,
      children = _ref.children;
  var classes = (0, _classnames.default)('ApplicationLayoutBodyBottomBar', buttonAlignment === 'left' && 'justify-content-start', buttonAlignment === 'right' && 'justify-content-end', buttonAlignment !== 'left' && buttonAlignment !== 'right' && 'justify-content-between', useBodyPaddings && 'use-body-padding', className && className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, children);
};

exports.ApplicationLayoutBodyBottomBar = ApplicationLayoutBodyBottomBar;
ApplicationLayoutBodyBottomBar.LEFT = 'left';
ApplicationLayoutBodyBottomBar.RIGHT = 'right';
ApplicationLayoutBodyBottomBar.defaultProps = {
  useBodyPaddings: false
};
ApplicationLayoutBodyBottomBar.propTypes = {
  className: _propTypes.default.string,
  useBodyPaddings: _propTypes.default.bool,
  buttonAlignment: _propTypes.default.oneOf([ApplicationLayoutBodyBottomBar.LEFT, ApplicationLayoutBodyBottomBar.RIGHT])
};
var _default = ApplicationLayoutBodyBottomBar;
exports.default = _default;